import { FC, useId } from 'react';

interface CoBrandingSeparatorProps {
    /** Width and height in px */
    size: number;
    start: string;
    end: string;
}

/** The "×" between the two brands, stroked in the carrier's gradient. */
const CoBrandingSeparator: FC<CoBrandingSeparatorProps> = ({ size, start, end }) => {
    const gradientId = `co-branding-separator-${useId()}`;

    return (
        <svg width={size} height={size} viewBox="0 0 9 9" fill="none" aria-hidden="true" focusable="false">
            <defs>
                <linearGradient id={gradientId} x1="0" y1="9" x2="9" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stopColor={start} />
                    <stop offset="1" stopColor={end} />
                </linearGradient>
            </defs>
            <path
                d="M0.5 8.5L8.5 0.5M0.5 0.5L8.5 8.5"
                stroke={`url(#${gradientId})`}
                strokeWidth={1}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default CoBrandingSeparator;
